var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSkillsFramework = function SvgSkillsFramework(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M9.266 2.162a1.75 1.75 0 0 1 1.468 0l6.832 3.156A.75.75 0 0 1 18 6c0 .293-.169.559-.434.68l-6.832 3.157a1.75 1.75 0 0 1-1.468 0L2.434 6.681a.75.75 0 0 1 0-1.363zm6.637 6.388 1.663.769A.75.75 0 0 1 18 10c0 .294-.169.56-.434.681l-6.832 3.157a1.75 1.75 0 0 1-1.468 0L2.434 10.68a.75.75 0 0 1 0-1.363l1.663-.768 4.75 2.194a2.75 2.75 0 0 0 2.306 0zm-4.75 6.194 4.75-2.194 1.663.77A.75.75 0 0 1 18 14c0 .294-.169.56-.434.682l-6.832 3.156a1.75 1.75 0 0 1-1.468 0l-6.832-3.156a.75.75 0 0 1 0-1.363l1.663-.769 4.75 2.194a2.75 2.75 0 0 0 2.306 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSkillsFramework);
export default ForwardRef;